import Action from '../Action';
import CityService from '../../services/CityService';
import { message } from 'antd';

export function fetchCities() {
	return (dispatch) => {
		CityService.get()
			.then((cities) => {
				dispatch({ type: Action.FETCH_CITIES, cities: cities.data });
			})
			.catch((error) => message.error('Failed to fetch cities!'));
	};
}

export function addCity(body) {
	return (dispatch) => {
		CityService.add(body)
			.then((city) => {
				dispatch({ type: Action.ADD_CITY, city: city.data });
				message.success('City Added');
			})
			.catch((error) => message.error('Failed to add city!'));
	};
}

export function updateCity(id, body) {
	return (dispatch) => {
		CityService.update(id, body)
			.then((city) => {
				dispatch({ type: Action.UPDATE_CITY, city: city.data });
				message.success('City Updated');
			})
			.catch((error) => message.error('Failed to edit city!'));
	};
}

export function deleteCity(id) {
	return (dispatch) => {
		CityService.delete(id)
			.then((city) => {
				dispatch({ type: Action.DELETE_CITY, city: city.data });
				message.success('City Deleted');
			})
			.catch((error) => message.error('Failed to delete city!'));
	};
}
